import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18next';
import { ModificationTrackingForm } from 'core/forms';
import pick from 'lodash/pick';

import { Typo } from 'uikit/content';

import getDateTimeString from '../helpers/getDateTimeString';

import styles from '../styles/multiModificationTrackingForm.module.scss';

const MultiModificationTrackingForm = ({
  hasTimestamp = false,
  model = {},
  onCancel = () => {},
  onSubmit = async () => {},
  onUpdate = () => {},
  schemas = [],
}) => (
  <>
    {schemas.map(({ schema, title }) => (
      <Fragment key={title}>
        <Typo className={styles.title} element="h2" variant="d01">
          {title}
        </Typo>
        <ModificationTrackingForm
          model={pick(model, Object.keys(schema))}
          modifiedClassName={styles.isModified}
          onCancelClick={onCancel}
          onFormLoad={onUpdate}
          onSaveClick={onSubmit}
          onFormUpdate={onUpdate}
          schema={schema}
        />
      </Fragment>
    ))}
    {hasTimestamp && (
      <div className={styles.timestamp}>
        <Typo color="secondary" variant="s01">
          {i18n.t('last-updated-by-user-on-date', {
            date: getDateTimeString(model.updated_at),
            user: model.updated_by,
          })}
        </Typo>
        <Typo color="secondary" variant="s01">
          {i18n.t('id-prefix-label', { id: model.id })}
        </Typo>
      </div>
    )}
  </>
);

MultiModificationTrackingForm.propTypes = {
  hasTimestamp: PropTypes.bool,
  model: PropTypes.shape({}),
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  onUpdate: PropTypes.func,
  schemas: PropTypes.arrayOf(PropTypes.shape({})),
};

export default MultiModificationTrackingForm;
